import lockerSignupPic from "../assets/images/coming-soon-pic.jpg"
import Footer from "../components/Footer";
import Navbar from "../components/Navbar";

interface LockerSignupLayoutProps {
  children: React.ReactNode;
}

const LockerSignupLayout: React.FC<LockerSignupLayoutProps> = ({ children }) => {

  return (
    <main className="pageOuterWrapper">
      <Navbar />
      
        <div className="lockerPageWrapper">
            <h1>League Locker Sign-up</h1>
            <div className="lockerSignupPic">
                <img src={lockerSignupPic} alt="" />
            </div>
            <div className="formWrapper">
                {children}        
            </div>
        </div>
      
      <Footer />
    </main>
  );
};

export default LockerSignupLayout;
